import PartyPackageCard from './PartyPackageCard';
import PartyPackageCardSkeleton from './PartyPackageCardSkeleton';
import hero from "./image/food-img.png";
import './PartyPackageListingPage.css';
import searchIcon from './image/search-icon.svg'
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { FiSettings } from "react-icons/fi";
import { FaHeart, FaUsers, FaRupeeSign, FaHistory, FaStar } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { RxDotFilled } from "react-icons/rx";
import FilterBar from './FilterBar';
import FilterModal from './FilterModel';


const filters = [
    {
        "label": "Filter",
        "type": "button",
        "icon": "PiSlidersHorizontalBold"
    },
    {
        "label": "Sort By",
        "type": "dropdown",
        "group": "sort",
        "icon": "IoIosArrowDown",
        "options": ["A to Z", "Z to A",]
    },

    {
        "label": "Review",
        "type": "dropdown",
        "icon": "IoIosArrowDown",
        "options": ["1 stars", "2 stars", "3 stars", "4 stars", "5 stars"]
    },
    {
        "label": "My Favorite",
        "type": "pill",
        "icon": "FaHeart"
    },
    {
        "label": "Friends Favorite",
        "type": "pill",
        "icon": "FaUsers"
    },
    {
        "label": "Under 999",
        "type": "pill",
        "icon": "FaRupeeSign"
    },
    {
        "label": "Previously Booked",
        "type": "pill",
        "icon": "FaHistory"
    },
    {
        "label": "New to You",
        "type": "pill",
        "icon": "FaStar"
    }
]



export default function PartyPackageListingPage() {

    const location = useLocation();
    const navigate = useNavigate();
    const pathname = location.pathname;

    const segments = pathname.split('/').filter(Boolean);
    const pageSlug = segments[segments.length - 1];

    const pageName = pageSlug.replace(/-/g, ' ');


    const [data, setData] = useState([]);
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [keyword, setKeyword] = useState("");
    const [selectedMenuIds, setSelectedMenuIds] = useState([]);
    const [titleData, setTitleData] = useState([]);
    const [selectedTitle, setSelectedTitle] = useState("Imported Drinks + Food");
    const [filtersAndSort, setFiltersAndSort] = useState({});

    const [showFilter, setShowFilter] = useState(false);


    const [visibleCount, setVisibleCount] = useState(6);

    const loaderRef = useRef(null);

    const fetchData = (latitude, longitude, selectedMenuIds = [], packageIds = []) => {
        const formData = new FormData();
        formData.append("latitude", latitude);
        formData.append("longitude", longitude);
        formData.append("venue_id", selectedMenuIds.join(","));
        formData.append("title", packageIds.join(","));
        formData.append("keyword", keyword);

        axios
            .post(
                "https://partywitty.com/master/APIs/ClubPackage/allPackages",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            )
            .then((response) => {
                if (response.data.status === true) {
                    setData(response.data.data);
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setLatitude(latitude.toString());
                    setLongitude(longitude.toString());
                    fetchData(latitude, longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                }
            );
        } else {
            console.error("Geolocation is not available in this browser.");
        }
    }, []);

    // const handleClick = (title) => {
    //     const formattedTitle = title.name
    //         .toLowerCase()
    //         .replace(/[^a-z0-9\s]/gi, "")
    //         .trim()
    //         .replace(/\s+/g, "-");

    //     setSelectedTitle(title.name);
    //     navigate(`/party-packages-${formattedTitle}`);
    // };


    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisibleCount((prev) => prev + 6);
                }
            },
            { threshold: 1 }
        );

        if (loaderRef.current) {
            observer.observe(loaderRef.current);
        }

        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, []);


    useEffect(() => {
        axios
            .get(" https://partywitty.com/master/APIs/ClubPackage/getPackageTypes")
            .then((response) => {
                setTitleData(response.data.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");

        return `/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    }




    const fetchDataWithFilters = () => {
        console.log("filtersAndSort sdfhasjkdf");
        const venueIds = filtersAndSort?.venue || [];
        const packageIds = filtersAndSort?.package || [];
        fetchData(latitude, longitude, venueIds, packageIds);
    };


    const filteredData = data.filter((item) => {
        if (filtersAndSort.selectedDropdowns?.Review) {
            const selectedReview = parseInt(filtersAndSort.selectedDropdowns.Review[0]);
            const itemRating = parseFloat(item.totalAverageRating);

            const lowerBound = selectedReview - 0.4;
            const upperBound = selectedReview + 0.5;

            if (isNaN(itemRating) || itemRating < lowerBound || itemRating >= upperBound) {
                return false;
            }
        }


        // if (filtersAndSort.selectedPills.includes("Friends Favorite") && !item.isFriendFavorite) {
        //     return false;
        // }

        // if (filtersAndSort.selectedPills.includes("Under 999") && item.price >= 999) {
        //     return false;
        // }

        return true;
    }).sort((a, b) => {
        const sortType = filtersAndSort.selectedDropdowns?.["Sort By"];
        if (sortType === "A to Z") return a.title.localeCompare(b.title);
        if (sortType === "Z to A") return b.title.localeCompare(a.title);
        return 0;
    });


    return (
        <>
            <div className='party-package-list'>
                <div className="partypackage-hero-container">
                    <div className="partypackage-image-wrapper">
                        <img src={hero} alt="Event" className="partypackage-image" />
                        <div className="partypackage-overlay">
                            <div className="partypackage-title">
                                <h1>{pageName}</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='party-package-page-filter-container'>
                    <div className='party-package-page-filter'>
                        <div className='party-package-page-filter-title-box'>

                            <div className='pppftb-filter'>
                                <FilterBar filterList={filters} setFiltersAndSort={setFiltersAndSort} setShowFilter={setShowFilter} />
                            </div>
                        </div>

                    </div>
                </div>

                <div className='party-package-page-container'>
                    {data.length === 0 ? (
                        Array.from({ length: 6 }).map((_, index) => (
                            <PartyPackageCardSkeleton key={index} />
                        ))
                    ) : (
                        filteredData.slice(0, visibleCount).map((item, index) => (
                            <Link
                                to={generateClubUrl(item.clubName, item.cityName, item.areaName, item.title)}
                                key={index}
                            >
                                <PartyPackageCard data={item} isListingPage={true} isVenueList={false} />
                            </Link>
                        ))

                    )}
                    <div ref={loaderRef} style={{ height: "1px" }} />
                </div>
            </div>
            <FilterModal isOpen={showFilter} onClose={() => setShowFilter(false)} setFiltersAndSort={setFiltersAndSort} fetchDataWithFilters={fetchDataWithFilters} />
        </>
    );
}
